import { render, staticRenderFns } from "./VerCupones.vue?vue&type=template&id=3251d0a0&"
import script from "./VerCupones.vue?vue&type=script&lang=js&"
export * from "./VerCupones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports